export default __webpack_public_path__ + "static/media/IFeelSick_13.7224f7fe.png";